module.exports = __webpack_public_path__ + "static/media/orlando_team.2f5bf6e8.jpg";